module.exports = __webpack_public_path__ + "img/Slice 268@2x(5).4ee5febc.png";